(function () {
  'use strict';

  // Selectors to anchor the injected button after, if not found in DOM
  var ANCHOR_SELECTORS = [
    '.quantity-submit-row',
    '.buy-buttons-block',
    '.product-form__buttons',
    '[name="add"]',
    '.shopify-payment-button'
  ];

  function findAnchor() {
    for (var i = 0; i < ANCHOR_SELECTORS.length; i++) {
      var el = document.querySelector(ANCHOR_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function initWishlistButton(swat) {
    var btn = document.querySelector('#swym-pdp-wishlist-btn');

    if (!btn) {
      var anchor = findAnchor();
      if (!anchor) return;
      btn = document.createElement('button');
      btn.id = 'swym-pdp-wishlist-btn';
      btn.type = 'button';
      btn.setAttribute('aria-label', 'Add to wishlist');
      btn.innerHTML = svgHeart();
      anchor.parentNode.insertBefore(btn, anchor.nextSibling);
    }

    var pageData = window.SwymPageData;
    if (!pageData || pageData.et !== 1) return;

    var product = {
      epi: pageData.epi,
      empi: pageData.empi,
      du: pageData.du,
      dt: pageData.dt,
      iu: pageData.iu,
      pr: pageData.pr
    };

    checkState(swat, btn, product);

    btn.addEventListener('click', function () {
      if (btn.classList.contains('swym-added')) {
        swat.removeFromWishList(product, function () {
          updateButtonState(btn, false);
          document.dispatchEvent(new CustomEvent('on:wishlist:changed'));
        });
      } else {
        swat.addToWishList(product, function () {
          updateButtonState(btn, true);
          document.dispatchEvent(new CustomEvent('on:wishlist:changed'));
        });
      }
    });

    // Theme variant change event (on:variant:change fires with detail.variant)
    document.addEventListener('on:variant:change', function (evt) {
      var variant = evt.detail && evt.detail.variant;
      if (!variant) return;
      applyVariantData(swat, btn, product, variant.id);
    });

    // Swym native variant changed event
    if (swat.evtLayer && swat.JSEvents && swat.JSEvents.variantChanged) {
      swat.evtLayer.addEventListener(swat.JSEvents.variantChanged, function (evt) {
        var variantData = evt && evt.detail && evt.detail.d;
        if (!variantData) return;
        var variantId = variantData.variant ? variantData.variant.id : null;
        if (!variantId) return;
        applyVariantData(swat, btn, product, variantId);
      });
    }
  }

  function applyVariantData(swat, btn, product, variantId) {
    var variantInfo = window.SwymProductVariants && window.SwymProductVariants[variantId];
    if (variantInfo) {
      product.epi = variantInfo.epi;
      product.pr  = variantInfo.pr;
      product.iu  = variantInfo.iu || product.iu;
    } else {
      product.epi = variantId;
    }
    checkState(swat, btn, product);
  }

  function checkState(swat, btn, product) {
    swat.fetch(function (wishlisted) {
      var found = wishlisted.some(function (item) {
        return item.empi === product.empi && item.epi === product.epi;
      });
      updateButtonState(btn, found);
    });
  }

  function updateButtonState(btn, isWishlisted) {
    if (!btn) return;
    btn.hidden = false;
    btn.classList.toggle('swym-added', isWishlisted);
    var label = isWishlisted ? 'Remove from wishlist' : 'Add to wishlist';
    btn.setAttribute('aria-label', label);
    var span = btn.querySelector('.swym-pdp-wishlist-btn__label');
    if (span) span.textContent = isWishlisted ? 'Remove from Wishlist' : 'Add to Wishlist';
  }

  function svgHeart() {
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">'
      + '<path class="swym-heart-outline" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>'
      + '<path class="swym-heart-filled" fill="currentColor" d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>'
      + '</svg>';
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(initWishlistButton);
})();
